import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export const ActionsMenuCell = ({
  projectId,
  onChangeStatus,
  onEditProject,
  clearEditMode,
}: {
  projectId: string;
  onChangeStatus: (projectId: string) => void;
  onEditProject: (projectId: string) => void;
  clearEditMode: () => void;
}) => {
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    clearEditMode();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeStatusClick = () => {
    onChangeStatus(projectId);
    handleClose();
  };

  const handleEditProjectClick = () => {
    onEditProject(projectId);
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleChangeStatusClick}>
          <ListItemIcon>
            <SwapHorizIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {formatMessage({ id: 'adminProjects.actionsMenu.changeStatus' })}
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleEditProjectClick}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {formatMessage({ id: 'adminProjects.actionsMenu.editProject' })}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
